import React from 'react'
import { Tab as MuiTab, Tabs as MuiTabs } from '@mui/material'
import makeStyles from '@mui/styles/makeStyles'

const useStyles = makeStyles(({ spacing, palette }) => ({
  tab: {
    textTransform: 'none',
    fontSize: '1rem'
  },
  indicator: {
    // @@@ Should presumably be in a palette somewhere (primary/90 in Figma)
    backgroundColor: '#001726'
  }
}))

const Tabs = ({ labels, disabled, value, onChange }) => {
  const classes = useStyles()

  const handleChange = (event, newValue) => {
    onChange(newValue)
  }

  return (
    <MuiTabs
      value={value}
      onChange={handleChange}
      variant='scrollable'
      classes={{ indicator: classes.indicator }}
    >
      {labels.map((label, index) => (
        <MuiTab
          label={label}
          index={index}
          key={label}
          disabled={disabled}
          className={classes.tab}
          data-test={`tabbed-panel-tab-${index}`}
        />
      ))}
    </MuiTabs>
  )
}

export default Tabs
